var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftManage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 9.18311C11.4032 9.18311 13.25 7.33628 13.25 5.05811C13.25 2.77993 11.4032 0.933105 9.125 0.933105C6.84683 0.933105 5 2.77993 5 5.05811C5 7.33628 6.84683 9.18311 9.125 9.18311Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9375 16.3171V14.7758C8.9375 14.4271 9.0755 14.0933 9.32225 13.8473L10.8148 12.3548C10.778 11.5418 11.006 10.7183 11.4958 10.0253C10.751 9.89859 9.95375 9.82959 9.125 9.82959C6.6335 9.82959 4.42775 10.4528 3.05825 11.3866C2.0135 12.0991 1.4375 13.0043 1.4375 13.9546V15.0421C1.4375 15.3803 1.57175 15.7051 1.811 15.9436C2.05025 16.1828 2.37425 16.3171 2.7125 16.3171H8.9375Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.114 15.1561C15.023 15.2926 15.9837 15.0106 16.6835 14.3109C17.855 13.1394 17.855 11.2374 16.6835 10.0666C15.5127 8.89511 13.6107 8.89511 12.4392 10.0666C11.7395 10.7664 11.4575 11.7271 11.594 12.6369L9.8525 14.3776C9.74675 14.4834 9.6875 14.6266 9.6875 14.7759V16.5001C9.6875 16.8106 9.9395 17.0626 10.25 17.0626H11.9742C12.1235 17.0626 12.2667 17.0034 12.3725 16.8976L14.114 15.1561ZM13.9865 12.7636C13.6693 12.4464 13.6693 11.9311 13.9865 11.6139C14.3038 11.2966 14.819 11.2966 15.1362 11.6139C15.4535 11.9311 15.4535 12.4464 15.1362 12.7636C14.819 13.0809 14.3038 13.0809 13.9865 12.7636Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftManage);
export default __webpack_public_path__ + "static/media/LeftManage.ac40817b1a457490f684c9ae2e21d79b.svg";
export { ForwardRef as ReactComponent };